import http from '@/utils/http';

const baseUrl = '/rastreabilidade/documentos-raizen';

export default {
    baixarModeloCsv(modulo) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseUrl + `/download-modelo-csv?modulo=${modulo}`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: 'Preparando dados para download'
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    }
};
